export default __webpack_public_path__ + "static/media/GraftCafe-5.8d242209.jpg";